import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, Kindergarten } from '@isophi/core-legacy';
import { TranslocoService } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transfer-workplace-modal',
  templateUrl: './transfer-workplace-modal.component.html',
  styleUrls: ['./transfer-workplace-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TransferWorkplaceModalComponent implements OnInit {
  @Input() titleKey = 'transfer/changeWorkplaceTitle';
  @Input() labelKey = 'transfer/moveClassToWorkplace';
  @Input() currentWorkplaceUuid: string | null = null;

  workplaces: Kindergarten[] = [];

  form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public translocoService: TranslocoService
  ) {
    this.form = this.formBuilder.group({
      workplaceUuid: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    const teacher = this.authService.loggedUser?.teacher;
    this.workplaces = (teacher?.kindergartens || []).filter((workplace) => workplace.uuid !== this.currentWorkplaceUuid);
  }

  get workplaceControl(): FormControl {
    return this.form.get('workplaceUuid') as FormControl;
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.activeModal.close({
      workplaceUuid: this.form.value.workplaceUuid,
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
